var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C4 10.6569 5.34315 12 7 12L11 12V13C11 14.1046 10.1046 15 9 15L3 15C1.89543 15 1 14.1046 1 13L1 7C1 5.89543 1.89543 5 3 5H4L4 9ZM13 1C14.1046 1 15 1.89543 15 3L15 9C15 10.1046 14.1046 11 13 11L7 11C5.89543 11 5 10.1046 5 9L5 3C5 1.89543 5.89543 1 7 1L13 1Z",
    fill: "#B9BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.592afceb7b2b1b0afe23b34371b61b5e.svg";
export { ForwardRef as ReactComponent };